import moment from "moment";
import { computed } from "@vue/composition-api";
export const useAIRDateRange = () => {
  const airDateRange = computed(() => ({
    dateTo: moment().endOf("year").subtract(1, "year").format("YYYY-MM-DD"),
    dateFrom: moment().startOf("year").subtract(1, "year").format("YYYY-MM-DD")
  }));
  return {
    airDateRange
  };
};